<template>
  <v-app dark>
    <v-navigation-drawer :clipped="clipped" v-model="drawer" fixed app>
      <v-list dense>
        <v-list-tile v-for="(item, i) in items" :key="i" @click="menuClicked(item)">
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat @click="logout()">Logout</v-btn>
    </v-toolbar>
    <v-content id="vContent" ref="vContent">
      <slot></slot>
    </v-content>
    <v-footer fixed app>
      <span>&copy; 2018 - {{title}}</span>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        clipped: true,
        drawer: false,
        items: [
          {
            icon: 'dashboard',
            title: 'Home',
            route: 'home'
          }
        ],
        title: 'Servidor de licenciamento WEB Toptic'
      }
    },
    methods: {
      menuClicked: function (itemClicked) {
        this.$router.push({ name: itemClicked.route })
      },
      logout: function () {
        window.location.href = '/licensing/logout'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/secure/Home.vue